import { render, staticRenderFns } from "./Page2AccordeonIE.vue?vue&type=template&id=39e3a0d6&"
import script from "./Page2AccordeonIE.vue?vue&type=script&lang=js&"
export * from "./Page2AccordeonIE.vue?vue&type=script&lang=js&"
import style0 from "./Page2AccordeonIE.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports